/* eslint-disable */
import store from '@/store';
import router from '@/router/config_routers';
import { CLIENT_BRANDING } from "@/utils/system_constants/constant";
import axios from 'axios';
import { createApp } from 'vue';
import App from './App.vue';
import '@/assets/css/global.css';

// Set axios defaults
axios.defaults.withCredentials = true;

const domain = window.CLIENT_DOMAIN;
const isValidDomain = domain && domain !== 'localhost';

const app = createApp(App, { isValidDomain });
app.use(store);
app.use(router);

// --------------------
// Dynamic Branding Logic
// --------------------


// fetch logos from frontend
const logo = require('@/assets/images/complyon/logos/complyon_logo_business.png');
const onboarding_image =  require('@/assets/images/complyon/pictures/onboarding_complyon.png');

app.config.globalProperties.$clientLogo = logo;
app.config.globalProperties.$clientImage = {
  onboarding: onboarding_image,
  background: onboarding_image
};



// Apply branding colors dynamically to CSS variables
const apply_branding_colors = (colors) => {
  const root = document.documentElement;
  const colorMap = {
    primary: '--primary-color',
    secondary: '--secondary-color',
    tertiary_colour: '--tertiary-color',
    accent: '--accent-color',
    highlight: '--highlight-color',
    new: '--new-color',
    text: '--text-color',
    gradient: '--gradient'
  };

  Object.entries(colorMap).forEach(([key, cssVar]) => {
    const value = Reflect.get(colors, key);
    if (value) {
      root.style.setProperty(cssVar, value);
    }
  });
};

const get_clean_domain = () => {
  const hostname = window.location.host.split(':')[0];
  const parts = hostname.split('.');
  parts.pop(); // Remove TLD

  const first = parts[0]?.toLowerCase();
  if (['uat', 'stage', 'staging', 'demo'].includes(first)) {
    parts.shift();
  }

  return parts.join('.');
};

// Set client branding globally on the Vue app instance
const set_client_branding = (branding_data) => {
  if (branding_data?.colors) {
    apply_branding_colors(branding_data.colors);
  }

  const domain_key = get_clean_domain();
  const selected_logo = Reflect.get(logos, domain_key);
  const selected_image = Reflect.get(images, domain_key);
  const selected_bg = Reflect.get(form_backgrounds, domain_key);

  // Set logo globally
  app.config.globalProperties.$clientLogo = selected_logo;

  // Set favicon dynamically (prefer favicon, fallback to logo)
  const favicon = document.querySelector('link[rel="icon"]');
  const selected_favicon = Reflect.get(favicons, domain_key);
  const selected_icon = selected_favicon || selected_logo; // prefer favicon, fallback to logo

  if (favicon && selected_icon) {
    favicon.href = selected_icon;
  }


  // Optional: add other assets
  app.config.globalProperties.$clientImage = {
    onboarding: selected_image,
    background: selected_bg
  };
};

// Fetch branding from backend API and apply it
const fetch_branding = () => {
  const domain = get_clean_domain();

  return axios.get(CLIENT_BRANDING, {
    params: { domain }
  })
    .then(response => {
      set_client_branding(response.data || {});
    })
    .catch(error => {
      console.warn("Failed to fetch client branding:", error);
  });
};

// --------------------
// Mount app after fetching branding
// --------------------
fetch_branding().finally(() => {
  app.mount('#app');
});
